// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__72p4y","horizontal":"Separator_horizontal__cy7S2","vertical":"Separator_vertical__Cpk85"};